import { IPhoneNumber } from '../../../../../../shared/redux/reducers';
import { getPhone } from '../../../../../../shared/utils';

export const getPhoneIndex = (phones: Array<IPhoneNumber> | undefined, phone: string | undefined): number | null => {
  if (!Array.isArray(phones) || !phone) {
    return null;
  }

  return phones.findIndex((phoneObject) => getPhone(phoneObject) === phone);
};
